import { getAdminRegionContext } from './adminRegionContext';
import type { AdminView } from './adminView';

export type AdminViewSwitchPolicy = {
  canSelectAnyRegion: boolean;
  showCompanyExit: boolean;
  showPlatformExit: boolean;
};

export type RegionSwitchMode = 'hidden' | 'disabled' | 'direct' | 'menu';

export const resolveAvailableAdminViews = (
  currentUser?: API.CurrentUser,
): AdminView[] => {
  const views = currentUser?.adminViews || currentUser?.admin_views || [];
  const scope = currentUser?.adminScope || currentUser?.admin_scope;
  if (views.length > 0) {
    const normalized = views.filter(
      (view): view is AdminView =>
        view === 'platform' || view === 'company' || view === 'region',
    );
    if (
      getAdminRegionContext()?.id &&
      !normalized.includes('region') &&
      (normalized.includes('company') ||
        normalized.includes('platform') ||
        scope === 'company' ||
        scope === 'platform')
    ) {
      return [...normalized, 'region'];
    }
    return normalized;
  }
  if (scope === 'platform') {
    return getAdminRegionContext()?.id
      ? ['platform', 'company', 'region']
      : ['platform', 'company'];
  }
  if (scope === 'company') {
    return getAdminRegionContext()?.id ? ['company', 'region'] : ['company'];
  }
  if (scope === 'region') return ['region'];
  return [];
};

export const resolveAdminViewSwitchPolicy = (
  currentUser: API.CurrentUser | undefined,
  activeView: AdminView,
): AdminViewSwitchPolicy => {
  const views = currentUser?.adminViews || currentUser?.admin_views || [];
  const scope = currentUser?.adminScope || currentUser?.admin_scope;
  const isAdmin = currentUser?.access === 'admin';
  const isPlatform =
    isAdmin && (scope === 'platform' || views.includes('platform'));
  const isCompany =
    isAdmin && (isPlatform || scope === 'company' || views.includes('company'));

  return {
    canSelectAnyRegion: isPlatform || isCompany,
    showCompanyExit: activeView === 'region' && isCompany,
    showPlatformExit: activeView !== 'platform' && isPlatform,
  };
};

export const resolveRegionSwitchMode = (
  canSelectAnyRegion: boolean,
  regionCount: number,
): RegionSwitchMode => {
  if (!canSelectAnyRegion) {
    return 'hidden';
  }
  if (regionCount <= 0) {
    return 'disabled';
  }
  if (regionCount === 1) {
    return 'direct';
  }
  return 'menu';
};
